import Barcode from "react-barcode";
import EnlargeOnClick from "../utilComponents/EnlargeOnClick";

const BarcodeComponent = ({ code, width = 2, height = 100, lineColor = "black", background = "white" }) => {
  return (
    <EnlargeOnClick>
      <div
        className="myBarcode"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          height: "100%",
          position: "relative",
        }}
      >
        
          <Barcode
            value={code}
            displayValue
            format={"CODE128"}
            width={width}
            height={height}
            style={{ display: "none" }}
            lineColor= {lineColor}
            background = {background}
          />
       
      </div>
    </EnlargeOnClick>
  );
};

export default BarcodeComponent;
